<template>
    <header class="header">

        <div class="filters">
            <app-date-range-filter data-entity="access"/>

            <app-devices-filter data-entity="access"/>

            <div></div>
        </div>

        <i class="mdi mdi-file-download-outline mr-4"
           v-tooltip.auto="'Exportar arquivo CSV'"
           @click="download"></i>

    </header>
</template>

<script>
    import AppDateRangeFilter from '@components/filters/DateRangeFilter'
    import AppDevicesFilter from '@components/filters/DevicesFilter'
    import EventBus from "@packages/event-bus";

    export default {
        components: {
            AppDateRangeFilter,
            AppDevicesFilter
        },
        mounted(){
            this.$store.commit('ACCESS_RESET_FILTERS')
        },

        methods: {
            async download() {
                EventBus.$emit('SHOW_SPINNER')
                const csv = await this.fetchCsv()

                const link = this.createElement(csv)

                link.click()
                EventBus.$emit('CANCEL_SPINNER')
            },

            async fetchCsv() {
                return this.$api.access.csv({filters: this.$store.state.access.filters})
            },

            createElement(csv) {
                const url = window.URL.createObjectURL(new Blob([csv]))
                const link = document.createElement('a')

                link.href = url
                link.setAttribute('download', 'leads.csv')
                document.body.appendChild(link)

                return link
            },
        },

    }
</script>

<style lang="scss" scoped>
    @import "~@variables";
    .header {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .filters {
            display: flex;
            align-items: center;
            justify-content: space-around;
            padding: 0 2% 0 12%;
            flex-grow: 1;

            .search-wrapper {
                max-width: 200px;
            }
        }

        .mdi {
            font-size: 28px;
            color: $grey-6;
            cursor: pointer;

            &.active {
                color: $blue-primary;
            }

            &.mdi-view-grid {
                font-size: 22px;
            }
        }
    }
</style>
